import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { WhatsappLogo } from "@phosphor-icons/react";
import { card, btnPrimary, waLink, errMsg } from "./shared";

function RequestRow({ r, onAccepted }) {
  const [open, setOpen] = useState(false);
  const accept = async () => {
    const win = window.open("", "_blank");
    try {
      const { data } = await api.post(`/market/requests/${r.request_id}/accept`);
      const url = waLink(data.customer_whatsapp, `Hi ${r.name}, ${r.business_name} here. We've accepted your request on Tainapp Market.`);
      if (win) win.location.href = url; else window.location.href = url;
      onAccepted();
    } catch (e) {
      win?.close();
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="border-b border-sky-100 last:border-0 py-3" data-testid={`incoming-request-${r.request_id}`}>
      <button className="w-full flex justify-between items-center text-left" onClick={() => setOpen(!open)} data-testid={`incoming-request-open-${r.request_id}`}>
        <span className="font-semibold text-sky-950">{r.name}</span>
        <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${r.status === "accepted" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>{r.status}</span>
      </button>
      {open && (
        <div className="mt-3 text-sm text-sky-900 space-y-1">
          <p><b>Gender:</b> {r.gender}</p>
          <p><b>Contact:</b> {r.contact}</p>
          <p><b>Location:</b> {r.location}</p>
          <p className="whitespace-pre-line"><b>Needs:</b> {r.description}</p>
          <button data-testid={`incoming-request-accept-${r.request_id}`} className={`${btnPrimary} mt-2`} onClick={accept}>
            <WhatsappLogo size={18} weight="fill" /> {r.status === "accepted" ? "Chat on WhatsApp" : "Accept"}
          </button>
        </div>
      )}
    </div>
  );
}

export function IncomingRequests({ requests, reload }) {
  return (
    <div className={`${card} p-5`} data-testid="incoming-requests">
      <p className="font-heading text-lg font-black text-sky-950 mb-2">Customer requests</p>
      {requests.length === 0 && <p className="text-sm text-sky-700/70">No requests yet.</p>}
      {requests.map((r) => <RequestRow key={r.request_id} r={r} onAccepted={reload} />)}
    </div>
  );
}
